import { createFileRoute } from "@tanstack/react-router";
import { GeneralPage } from "@/features/harvest-operation-template/general-page";

export const Route = createFileRoute(
  "/harvests/operation-templates/$template_id/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { template_id } = Route.useParams();
  return <GeneralPage templateId={template_id} />;
}
